import { BreakpointObserver } from '@angular/cdk/layout';
import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';

import { takeUntil, tap } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { ComponentBase } from 'app/shared/component.base';
import { AuthService } from 'app/shared/services/auth.service';
import { UserManagementService } from 'app/shared/services/user-management.service';

@Component({
    selector: 'app-locked-account',
    templateUrl: './locked-account.component.html',
    styleUrls: ['./locked-account.component.scss'],
    imports: [MatButtonModule, MatIconModule, RouterLink, MatMenuModule, NgClass, MatDialogModule, MatButtonModule]
})
export class LockedAccountComponent extends ComponentBase implements OnInit {
	lockReason: string;
	smallScreen = false;

	constructor(
		private userManagementService: UserManagementService,
		private authService: AuthService,
		private breakpointObserver: BreakpointObserver,
	) {
		super();

		breakpointObserver.observe(['(max-width: 40.5rem)']).subscribe((result) => {
			this.smallScreen = result.matches;
		});
	}

	ngOnInit(): void {
		this.userManagementService
			.getClientAccountDetailsV1()
			.pipe(
				takeUntil(this.ngUnsubscribe$),
				tap((response) => (this.lockReason = response.lockReason.toLowerCase())),
			)
			.subscribe();
	}

	logout() {
		this.authService.logout();
	}

	contactUsClicked() {
		window.open('https://www.wine-ark.com.au/contact/', '_blank', 'noopener');
	}

	viewInvoicesClicked() {
		window.open(`${environment.winePortalUrl}/history/invoices`, '_blank', 'noopener');
	}

	getTermsAndConditionsUrl(): string {
		return environment.winearkTermsAndConditionsUrl;
	}
}
